module.exports = __webpack_public_path__ + "static/media/storePurchase_500.27d4b432.png";